import {computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import {default as handleErrorToast} from "../../components/toast/ErrorToast";
import {default as handleSuccessToast} from "../../components/toast/SuccessToast";
import {CREATE_CUSTOMER_ONBOARDING_PATH} from "../../routes";

export default class ListCustomerOnboardingFeature {

    constructor(application, navigator) {
        this._application = application;
        this._navigate = navigator;
        this._loaded = false;
        this._customerOnboardings = [];
        this._buttonLoading = false;

        makeObservable(this, {
            _loaded: observable,
            _customerOnboardings: observable,
            loaded: computed,
            customerOnboardings: computed,
            _buttonLoading: observable,
            buttonLoading: computed,
        })
    }

    async load() {
        await this._getCustomerOnboardings()
        this.finishLoading()
    }

    finishLoading() {
        this._loaded = true
    }

    get loaded() {
        return this._loaded;
    }

    set loaded(value) {
        this._loaded = value;
    }

    get customerOnboardings() {
        return this._customerOnboardings;
    }

    set customerOnboardings(value) {
        this._customerOnboardings = value;
    }

    _simulateProcessingDelay() {
        setTimeout(() => {
            this._enableButton();
        }, 3000);
    }

    _enableButton() {
        this._buttonLoading = false;
    }

    _disableButton() {
        this._buttonLoading = true;
    }

    get buttonLoading() {
        return this._buttonLoading;
    }

    set buttonLoading(value) {
        this._buttonLoading = value
    }

    columnsContent() {
        return [
            {id: 'taxpayerIdentificationNumber', label: 'CUIT'},
            {id: 'businessName', label: 'Razón Social'},
            {id: 'state', label: 'Estado'},
            {id: 'requester', label: 'Solicitante'},
            {id: 'requestTimestamp', label: 'Fecha solicitud'},
            {id: 'closeDatetime', label: 'Fecha cierre'},
            {id: 'logisticsAuthorization', label: 'Logística'},
            {id: 'commercialAuthorization', label: 'Comercial'},
            {id: 'financeAuthorization', label: 'Financiera'},
            {id: 'taxAuthorization', label: 'Impositiva'},
        ];
    }

    canImportCustomerOnboardingsToERP() {
        return this._application.permissions().includes('ONBOARDINGS_ERP_IMPORTER_PERMISSION');
    }

    presentedCustomerOnboardings() {
        return this.customerOnboardings.map(customerOnboarding => {
            return this._presentedCustomerOnboarding(customerOnboarding);
        });
    }

    _presentedCustomerOnboarding(customerOnboarding) {
        return {
            id: customerOnboarding.request.taxpayerIdentificationNumber,
            taxpayerIdentificationNumber: customerOnboarding.request.taxpayerIdentificationNumber,
            businessName: customerOnboarding.request.businessName,
            state: customerOnboarding.state,
            requester: customerOnboarding.request.requester,
            requestTimestamp: customerOnboarding.request.requestTimestamp,
            closeDatetime: customerOnboarding.closeDatetime,
            logisticsAuthorization: customerOnboarding.logisticsAuthorization,
            commercialAuthorization: customerOnboarding.commercialAuthorization,
            financeAuthorization: customerOnboarding.financeAuthorization,
            taxAuthorization: customerOnboarding.taxAuthorization,
        }
    }

    async _getCustomerOnboardings() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this.customerOnboardings = response.customerOnboardings();
            },
            handlesError: (response) => {
                handleErrorToast('No se pudieron obtener las altas de clientes')
            }
        });
        return this._application.apiClient().customerOnboardings(responseHandler)
    }

    synchronizeERP() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._simulateProcessingDelay()
                handleSuccessToast('Sincronización finalizada con éxito')
            },
            handlesError: (response) => {
                this._simulateProcessingDelay()
                handleErrorToast('Fallo en la sincronización')
            }
        });
        this._disableButton()
        return this._application.apiClient().synchronizeWithERP(responseHandler)
    }

    navigateToCustomerOnboardingEditionScreen(row) {
        const taxpayerId = row.taxpayerIdentificationNumber;
        this._navigate(`/customer-onboardings/${taxpayerId}/edit`);
    }

    navigateToCreateCustomerOnboardingRequest() {
        this._navigate(CREATE_CUSTOMER_ONBOARDING_PATH)
    }

}